export default __webpack_public_path__ + "static/media/new_folder.d2cb998e.svg";